enum CardType {

  DEFAULT = 'default',
  FEATURED = 'featured',
  
}

export default CardType;
